import { ConfirmConsultationContainer } from '../containers/ConfirmConsultationContainer/index'

export const ConfirmConsultationPage = () => (
    <ConfirmConsultationContainer/>
)